import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api'; // <--- Importando a API centralizada

/* =============================================================
   ÍCONES SVG (DESIGN SYSTEM 3.0)
   ============================================================= */
const Icons = {
  Search: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Plus: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Edit: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Trash: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  Dollar: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  Refresh: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>,
  Box: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.29 8.83 12 13.71 20.71 8.83"/><line x1="12" y1="22.76" x2="12" y2="13.71"/></svg>,
  ArrowLeft: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>,
  Printer: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
};

export default function Estoque() {
  const [armações, setArmações] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Modais
  const [isModalOpen, setIsModalOpen] = useState(false);
  const[isEditModalOpen, setIsEditModalOpen] = useState(false);
  
  // Cadastro e Edição
  const[batchText, setBatchText] = useState('');
  const [selectedLojaCadastro, setSelectedLojaCadastro] = useState('Vizum 01');
  const [editingItem, setEditingItem] = useState(null);

  // Filtros
  const [searchTerm, setSearchTerm] = useState(''); // O que o usuário digita
  const [debouncedSearch, setDebouncedSearch] = useState(''); // O que dispara a API
  const [filterLoja, setFilterLoja] = useState('');
  const [filterMarca, setFilterMarca] = useState('');
  const [filterMaterial, setFilterMaterial] = useState('');

  // Estados de Animação
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true),[]);

  // =========================================================================
  // DEBOUNCE DA BUSCA: Aguarda 500ms após o usuário parar de digitar
  // =========================================================================
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchTerm), 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  // =========================================================================
  // CHAMADAS DE API (Agora usando Axios)
  // =========================================================================
  const carregarDados = useCallback(async () => {
    try {
      setLoading(true);
      
      // Monta os parâmetros apenas se existirem (evita enviar loja="" na URL)
      const params = {};
      if (filterLoja) params.loja = filterLoja;
      if (filterMarca) params.marca = filterMarca;
      if (filterMaterial) params.material = filterMaterial;
      if (debouncedSearch) params.ref = debouncedSearch;

      // O Axios já concatena os params na URL automaticamente
      const response = await api.get('/api/armacoes', { params });
      setArmações(response.data);
      
    } catch (error) { 
      console.error("Erro ao carregar estoque:", error);
      if (error.response?.status === 401) window.location.href = '/login';
    } finally { 
      setLoading(false); 
    }
  },[filterLoja, filterMarca, filterMaterial, debouncedSearch]);

  useEffect(() => { 
    carregarDados(); 
  },[carregarDados]);

  // =========================================================================
  // AÇÕES DO ESTOQUE
  // =========================================================================
  const limparFiltros = () => {
    setSearchTerm(''); setFilterLoja(''); setFilterMarca(''); setFilterMaterial('');
  };

  const handleEditClick = (item) => {
    setEditingItem({ ...item });
    setIsEditModalOpen(true);
  };

  const salvarEdicao = async () => {
    try {
      await api.put(`/api/armacoes/${editingItem._id}`, editingItem);
      setIsEditModalOpen(false); 
      carregarDados();
    } catch (error) { 
      alert("Erro ao salvar edição. Verifique sua conexão."); 
    }
  };

  const venderPeca = async (id) => {
    try {
      await api.patch(`/api/armacoes/vender/${id}`);
      carregarDados();
    } catch (error) { 
      alert("Erro ao registrar venda."); 
    }
  };

  const alterarQtd = async (id, delta) => {
    try {
      await api.patch(`/api/armacoes/quantidade/${id}`, { delta });
      carregarDados();
    } catch (error) { 
      alert("Erro ao alterar quantidade."); 
    }
  };

  const mudarLoja = async (id) => {
    try {
      await api.patch(`/api/armacoes/transferir/${id}`);
      carregarDados();
    } catch (error) { 
      alert("Erro na transferência de loja."); 
    }
  };

  const excluirRegistro = async (id) => {
    if (window.confirm("Tem certeza que deseja remover esta peça permanentemente?")) {
      try {
        await api.delete(`/api/armacoes/${id}`);
        carregarDados();
      } catch (error) { 
        alert("Erro ao excluir registro."); 
      }
    }
  };

  const processBatch = async () => {
    if (!batchText.trim()) return;
    
    const linhas = batchText.split('\n');
    const novosItens = linhas.map((linha) => {
      const partes = linha.trim().split(/\s+/);
      if (partes.length < 3) return null;
      return {
        loja: selectedLojaCadastro, marca: partes[0].toUpperCase(), material: partes[1],
        ref: partes[2], aro: partes[3] || '', ponte: partes[4] || '', haste: partes[5] || '',
        cor: partes[6] || '', qtd: 1, preco: 0
      };
    }).filter(item => item !== null);

    try {
      await api.post('/api/armacoes/batch', novosItens);
      setBatchText(''); 
      setIsModalOpen(false); 
      carregarDados();
    } catch (error) { 
      alert("Erro ao salvar entrada de estoque."); 
    }
  };

  // =========================================================================
  // ESTATÍSTICAS E RELATÓRIO
  // =========================================================================
  const calcularStats = (loja) => {
    const itens = loja ? armações.filter(a => a.loja === loja) : armações;
    return {
      unidades: itens.reduce((acc, cur) => acc + cur.qtd, 0),
      modelos: itens.length,
      esgotados: itens.filter(a => a.qtd === 0).length
    };
  };
  
  const statsGeral = calcularStats();
  const statsL01 = calcularStats('Vizum 01');
  const statsL02 = calcularStats('Vizum 02');

  const marcasDisponiveis =[...new Set(armações.map(item => item.marca.toUpperCase()))].sort();
  const materiaisDisponiveis =[...new Set(armações.map(item => item.material))].sort();

  const handlePrint = () => window.print();
  const dataAtual = new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

  return (
    <div style={{...styles.page, opacity: mounted ? 1 : 0, transition: 'opacity 0.6s ease'}}>
      <GlobalEstoqueStyles />

      {/* HEADER PREMIUM (No-Print) */}
      <header style={styles.header} className="no-print">
        <div style={styles.headerContent}>
          <div style={styles.brandArea}>
            <div style={styles.logoIcon}><Icons.Box /></div>
            <div>
              <h1 style={styles.title}>Gestão de Estoque</h1>
              <p style={styles.subtitle}>Controle de armações e inventário</p>
            </div>
          </div>
          <button onClick={() => window.location.href = '/home'} style={styles.backButton}>
            <Icons.ArrowLeft /> Voltar ao Dashboard
          </button>
        </div>
      </header>

      <main style={styles.main}>
        
        {/* KPI CARDS (No-Print) */}
        <section style={styles.statsGrid} className="no-print">
          <StatCard title="Estoque Total" value={statsGeral.unidades} sub={`${statsGeral.modelos} SKUs`} color="#0f172a" />
          <StatCard title="Vizum 01" value={statsL01.unidades} sub={`${statsL01.esgotados} Esgotados`} color="#2563eb" />
          <StatCard title="Vizum 02" value={statsL02.unidades} sub={`${statsL02.esgotados} Esgotados`} color="#d97706" />
        </section>

        {/* CABEÇALHO APENAS PARA IMPRESSÃO */}
        <div className="print-header">
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-end'}}>
                <div>
                    <h1 style={{margin:0, fontSize:'24px'}}>Relatório de Estoque</h1>
                    <p style={{margin:0, fontSize:'14px'}}>Gerado em: {dataAtual}</p>
                </div>
                <div style={{textAlign:'right'}}>
                    <p><strong>Total Itens Listados:</strong> {armações.length}</p>
                    <p><strong>Total Peças:</strong> {armações.reduce((a,b)=>a+b.qtd,0)}</p>
                </div>
            </div>
            {(filterLoja || filterMarca || filterMaterial) && (
                <div style={{marginTop: '10px', fontSize:'12px', fontStyle:'italic'}}>
                    Filtros: {filterLoja && `[Loja: ${filterLoja}] `} {filterMarca && `[Marca: ${filterMarca}] `} {filterMaterial && `[Mat: ${filterMaterial}]`}
                </div>
            )}
        </div>

        {/* TOOLBAR */}
        <div style={styles.toolbar} className="no-print">
          <div style={styles.searchSection}>
            <div style={styles.inputWrapper}>
              <span style={styles.searchIcon}><Icons.Search /></span>
              <input 
                style={styles.searchInput} 
                placeholder="Buscar referência, marca..." 
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)} 
              />
            </div>
            
            <select style={styles.select} value={filterMarca} onChange={(e) => setFilterMarca(e.target.value)}>
              <option value="">Marca: Todas</option>
              {marcasDisponiveis.map(m => <option key={m} value={m}>{m}</option>)}
            </select>

            <select style={styles.select} value={filterMaterial} onChange={(e) => setFilterMaterial(e.target.value)}>
              <option value="">Material: Todos</option>
              {materiaisDisponiveis.map(mat => <option key={mat} value={mat}>{mat}</option>)}
            </select>

            <select style={styles.select} value={filterLoja} onChange={(e) => setFilterLoja(e.target.value)}>
              <option value="">Loja: Todas</option>
              <option value="Vizum 01">Vizum 01</option>
              <option value="Vizum 02">Vizum 02</option>
            </select>

            {(searchTerm || filterMarca || filterLoja || filterMaterial) && (
              <button onClick={limparFiltros} style={styles.clearBtn}>Limpar</button>
            )}
          </div>

          <div style={{display:'flex', gap:'10px'}}>
             <button style={styles.printBtn} onClick={handlePrint} title="Gerar Relatório PDF">
                <Icons.Printer /> Imprimir
             </button>

             <button style={styles.addBtn} onClick={() => setIsModalOpen(true)}>
                <Icons.Plus /> Entrada Rápida
             </button>
          </div>
        </div>

        {/* TABLE */}
        <div style={styles.tableCard}>
          {loading ? (
            <div style={styles.loadingState}>
              <div className="spinner"></div>
              <span>Sincronizando inventário...</span>
            </div>
          ) : (
            <div style={{overflowX: 'auto'}}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.theadRow}>
                    <th style={styles.th}>Produto</th>
                    <th style={styles.th}>Características</th>
                    <th style={styles.th}>Localização</th>
                    <th style={{...styles.th, textAlign:'center'}}>Quantidade</th>
                    <th style={{...styles.th, textAlign:'right'}} className="actions-column">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {armações.map((item, idx) => (
                    <tr key={item._id} className="tr-hover" style={{...styles.tr, animationDelay: `${idx * 15}ms`}}>
                      <td style={styles.td}>
                        <div style={styles.prodCell}>
                          <span style={styles.brand}>{item.marca}</span>
                          <span style={styles.ref}>{item.ref}</span>
                        </div>
                      </td>
                      <td style={styles.td}>
                        <div style={styles.metaCell}>
                          <span>{item.material}</span>
                          <span style={styles.dot}>•</span>
                          <span>{item.cor}</span>
                          <span style={styles.dot}>•</span>
                          <span style={styles.dims}>{item.aro}□{item.ponte}-{item.haste}</span>
                        </div>
                      </td>
                      <td style={styles.td}>
                        <span style={item.loja === 'Vizum 01' ? styles.tagL1 : styles.tagL2}>
                          {item.loja}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <div style={styles.qtyWrapper}>
                          <button onClick={() => alterarQtd(item._id, -1)} style={styles.qtyBtn} className="qty-controls">-</button>
                          <span className="qty-display" style={{...styles.qtyNum, color: item.qtd === 0 ? '#ef4444' : '#0f172a'}}>{item.qtd}</span>
                          <button onClick={() => alterarQtd(item._id, 1)} style={styles.qtyBtn} className="qty-controls">+</button>
                        </div>
                      </td>
                      <td style={styles.td} className="actions-column">
                        <div style={styles.actionsCell} className="actions">
                          <button onClick={() => venderPeca(item._id)} style={styles.iconBtn} title="Vender Peça"><Icons.Dollar /></button>
                          <button onClick={() => mudarLoja(item._id)} style={styles.iconBtn} title="Transferir Loja"><Icons.Refresh /></button>
                          <button onClick={() => handleEditClick(item)} style={styles.iconBtn} title="Editar Cadastro"><Icons.Edit /></button>
                          <button onClick={() => excluirRegistro(item._id)} style={{...styles.iconBtn, color:'#ef4444', borderColor: '#fee2e2', background: '#fef2f2'}} title="Excluir"><Icons.Trash /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {armações.length === 0 && <div style={styles.emptyState}>Nenhum item encontrado com estes filtros.</div>}
            </div>
          )}
        </div>
      </main>

      {/* MODAL ENTRADA RÁPIDA */}
      {isModalOpen && (
        <ModalOverlay onClose={() => setIsModalOpen(false)} title="Entrada de Estoque em Lote">
          <div style={styles.modalBody}>
            <div style={styles.infoBox}>
              <strong>📋 Padrão de Cadastro Esperado:</strong>
              <p>MARCA MATERIAL REFERENCIA ARO PONTE HASTE COR</p>
              <small>Ex: RAYBAN ACETATO RB4105 54 18 140 PRETO</small>
            </div>
            
            <div style={styles.fieldGroup}>
              <label style={styles.label}>Loja de Destino</label>
              <select style={styles.selectFull} value={selectedLojaCadastro} onChange={(e) => setSelectedLojaCadastro(e.target.value)}>
                <option>Vizum 01</option>
                <option>Vizum 02</option>
              </select>
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>Dados (Cole do Excel ou digite)</label>
              <textarea 
                style={styles.codeArea} 
                value={batchText}
                onChange={(e) => setBatchText(e.target.value)}
                placeholder="Cole as linhas da sua planilha aqui..."
              />
            </div>

            <div style={styles.modalActions}>
              <button onClick={processBatch} style={styles.btnPrimary}>Processar e Salvar</button>
            </div>
          </div>
        </ModalOverlay>
      )}

      {/* MODAL EDIÇÃO */}
      {isEditModalOpen && editingItem && (
        <ModalOverlay onClose={() => setIsEditModalOpen(false)} title="Editar Produto">
          <div style={styles.modalBody}>
            <div style={styles.editGrid}>
              <Field label="Marca" value={editingItem.marca} onChange={v => setEditingItem({...editingItem, marca: v.toUpperCase()})} />
              <Field label="Material" value={editingItem.material} onChange={v => setEditingItem({...editingItem, material: v})} />
              <Field label="Referência" value={editingItem.ref} onChange={v => setEditingItem({...editingItem, ref: v})} />
              <Field label="Cor" value={editingItem.cor} onChange={v => setEditingItem({...editingItem, cor: v})} />
              <Field label="Aro" value={editingItem.aro} onChange={v => setEditingItem({...editingItem, aro: v})} />
              <Field label="Ponte" value={editingItem.ponte} onChange={v => setEditingItem({...editingItem, ponte: v})} />
            </div>
            <div style={styles.modalActions}>
              <button onClick={salvarEdicao} style={styles.btnPrimary}>Salvar Alterações</button>
            </div>
          </div>
        </ModalOverlay>
      )}
    </div>
  );
}

// =========================================================================
// SUB-COMPONENTES AUXILIARES
// =========================================================================
const StatCard = ({ title, value, sub, color }) => (
  <div style={{...styles.statCard, borderTop: `4px solid ${color}`}}>
    <span style={{color: color, fontSize:'11px', fontWeight:'700', textTransform:'uppercase'}}>{title}</span>
    <h3 style={{fontSize:'28px', margin:'5px 0', color:'#0f172a'}}>{value}</h3>
    <span style={{fontSize:'12px', color:'#64748b'}}>{sub}</span>
  </div>
);

const ModalOverlay = ({ children, onClose, title }) => (
  <div style={styles.overlay} className="no-print" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
    <div style={styles.modal}>
      <div style={styles.modalHeader}>
        <h3 style={{margin: 0, fontSize: '18px', color: '#0f172a'}}>{title}</h3>
        <button onClick={onClose} style={styles.closeBtn}>✕</button>
      </div>
      {children}
    </div>
  </div>
);

const Field = ({ label, value, onChange }) => (
  <div style={styles.fieldGroup}>
    <label style={styles.label}>{label}</label>
    <input style={styles.input} value={value} onChange={e => onChange(e.target.value)} />
  </div>
);

// =========================================================================
// ESTILOS CSS-IN-JS & TAG STYLE GLOBAL
// =========================================================================
const GlobalEstoqueStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
    
    * { box-sizing: border-box; }
    ::-webkit-scrollbar { width: 8px; height: 8px; }
    ::-webkit-scrollbar-track { background: #f1f5f9; }
    ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
    ::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
    
    .fade-in { animation: fadeIn 0.4s ease-out forwards; opacity: 0; }
    @keyframes fadeIn { to { opacity: 1; transform: translateY(0); } from { opacity: 0; transform: translateY(10px); } }
    
    .tr-hover { transition: background-color 0.2s; }
    .tr-hover:hover { background-color: #f8fafc; }
    .tr-hover:hover .actions { opacity: 1; }
    .actions { opacity: 0.3; transition: opacity 0.2s; }

    /* Estilo do Loading Spinner */
    .spinner {
      border: 3px solid rgba(0,0,0,0.05); border-left-color: #2563eb;
      border-radius: 50%; width: 24px; height: 24px; animation: spin 1s linear infinite;
      margin: 0 auto 10px auto;
    }
    @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

    /* Foco acessível nos inputs */
    input:focus, select:focus, textarea:focus {
      outline: 2px solid #2563eb; outline-offset: -1px; border-color: transparent !important;
    }

    /* Impressão */
    @media print {
        @page { margin: 1cm; size: landscape; }
        body { background-color: white !important; -webkit-print-color-adjust: exact; }
        header, .no-print, .actions-column, .qty-controls { display: none !important; }
        .print-header { display: block !important; margin-bottom: 20px; border-bottom: 2px solid #000; padding-bottom: 10px; }
        main { padding: 0 !important; margin: 0 !important; max-width: 100% !important; }
        div { box-shadow: none !important; border: none !important; overflow: visible !important; }
        table { width: 100% !important; border-collapse: collapse !important; font-size: 10pt !important; }
        th { background-color: #f1f5f9 !important; color: #000 !important; border: 1px solid #ddd !important; padding: 8px !important; }
        td { border: 1px solid #ddd !important; padding: 6px !important; color: #000 !important; }
        tr { page-break-inside: avoid; }
        span, div, p { color: #000 !important; }
        button { display: none !important; }
        .qty-display { display: inline !important; font-weight: bold; }
    }
    .print-header { display: none; }
  `}</style>
);

const styles = {
  page: { minHeight: '100vh', background: '#f8fafc', fontFamily: '"Plus Jakarta Sans", sans-serif', color: '#0f172a' },
  
  header: { background: '#0f172a', padding: '20px 40px', color: '#fff', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' },
  headerContent: { maxWidth: '1400px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  brandArea: { display: 'flex', alignItems: 'center', gap: '15px' },
  logoIcon: { width: '40px', height: '40px', background: 'rgba(255,255,255,0.1)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' },
  title: { margin: 0, fontSize: '20px', fontWeight: '700', letterSpacing: '-0.5px' },
  subtitle: { margin: 0, fontSize: '13px', color: '#94a3b8' },
  backButton: { background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: '#fff', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', transition: 'background 0.2s' },

  main: { maxWidth: '1400px', margin: '0 auto', padding: '40px 20px' },

  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', marginBottom: '30px' },
  statCard: { background: '#fff', padding: '24px', borderRadius: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0' },

  toolbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '20px' },
  searchSection: { display: 'flex', gap: '12px', flex: 1, flexWrap: 'wrap' },
  inputWrapper: { position: 'relative', display: 'flex', alignItems: 'center', minWidth: '300px' },
  searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
  searchInput: { width: '100%', padding: '12px 12px 12px 40px', borderRadius: '10px', border: '1px solid #cbd5e1', outline: 'none', fontSize: '14px', transition: 'border 0.2s' },
  select: { padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', fontSize: '14px', outline: 'none' },
  clearBtn: { background: 'none', border: 'none', color: '#ef4444', fontSize: '13px', cursor: 'pointer', fontWeight: '600', padding: '0 10px' },
  
  addBtn: { background: '#0f172a', color: '#fff', border: 'none', padding: '12px 20px', borderRadius: '10px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', transition: 'background 0.2s' },
  printBtn: { background: '#fff', color: '#334155', border: '1px solid #cbd5e1', padding: '12px 20px', borderRadius: '10px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', transition: 'background 0.2s' },

  tableCard: { background: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.05)', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  theadRow: { background: '#f8fafc', borderBottom: '1px solid #e2e8f0' },
  th: { padding: '16px 24px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' },
  tr: { borderBottom: '1px solid #f1f5f9', animation: 'fadeIn 0.5s ease forwards', opacity: 0 },
  td: { padding: '16px 24px', verticalAlign: 'middle' },
  
  prodCell: { display: 'flex', flexDirection: 'column' },
  brand: { fontWeight: '700', color: '#0f172a', fontSize: '14px' },
  ref: { fontSize: '13px', color: '#64748b', fontWeight: '500', marginTop: '2px' },
  
  metaCell: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#475569' },
  dot: { fontSize: '8px', color: '#cbd5e1' },
  dims: { fontFamily: 'monospace', background: '#f1f5f9', padding: '3px 6px', borderRadius: '6px', fontSize: '12px', color: '#64748b' },

  tagL1: { background: '#eff6ff', color: '#2563eb', padding: '4px 10px', borderRadius: '8px', fontSize: '12px', fontWeight: '600' },
  tagL2: { background: '#fff7ed', color: '#ea580c', padding: '4px 10px', borderRadius: '8px', fontSize: '12px', fontWeight: '600' },

  qtyWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '4px', width: 'fit-content', margin: '0 auto', background: '#f8fafc' },
  qtyBtn: { width: '26px', height: '26px', background: '#fff', border: '1px solid #cbd5e1', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontWeight: 'bold', transition: 'all 0.2s' },
  qtyNum: { fontSize: '14px', fontWeight: '700', minWidth: '24px', textAlign: 'center' },

  actionsCell: { display: 'flex', justifyContent: 'flex-end', gap: '6px' },
  iconBtn: { width: '32px', height: '32px', borderRadius: '8px', border: '1px solid transparent', background: 'transparent', color: '#64748b', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' },

  emptyState: { padding: '60px', textAlign: 'center', color: '#94a3b8', fontSize: '14px' },
  loadingState: { padding: '80px 20px', textAlign: 'center', color: '#64748b', fontSize: '14px', display: 'flex', flexDirection: 'column', alignItems: 'center' },

  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.4)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: '#fff', width: '90%', maxWidth: '550px', borderRadius: '20px', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', animation: 'fadeIn 0.3s ease' },
  modalHeader: { padding: '24px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  closeBtn: { background: '#f1f5f9', border: 'none', width: '32px', height: '32px', borderRadius: '50%', fontSize: '14px', cursor: 'pointer', color: '#64748b', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.2s' },
  modalBody: { padding: '24px' },
  
  infoBox: { background: '#f0f9ff', padding: '16px', borderRadius: '12px', border: '1px solid #bae6fd', fontSize: '13px', color: '#0369a1', marginBottom: '24px' },
  fieldGroup: { marginBottom: '16px' },
  label: { fontSize: '12px', fontWeight: '600', color: '#475569', marginBottom: '8px', display: 'block' },
  input: { width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1', fontSize: '14px', boxSizing: 'border-box' },
  selectFull: { width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1', background: '#fff', outline: 'none' },
  codeArea: { width: '100%', height: '120px', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1', fontFamily: 'monospace', fontSize: '13px', resize: 'vertical', outline: 'none' },
  editGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
  modalActions: { marginTop: '32px', display: 'flex', justifyContent: 'flex-end' },
  btnPrimary: { background: '#2563eb', color: '#fff', padding: '12px 24px', borderRadius: '10px', border: 'none', fontWeight: '600', cursor: 'pointer', transition: 'background 0.2s' }
};